<template>
  <header>

    <div class="uk-navbar-container uk-sticky-fixed" uk-sticky>
      <div class="uk-container uk-container-expand">

        <nav class="uk-light" uk-navbar="boundary-align: true; align: right;">
          <div class="uk-navbar-left">
            <div class="uk-navbar-item">
              <router-link :to="{ name: 'VirtualMachines' }" class="uk-logo">
                <img src="@/assets/images/logo-alt.svg" height="40" width="88" uk-svg />
              </router-link>
            </div>
          </div>
          <div class="uk-navbar-right">
            <ul class="uk-navbar-nav uk-visible@m">
              <li>
                <a href="#">
                  Hello, {{ first_name ? first_name : 'User' }}
                  <span uk-icon="icon: chevron-down;"></span>
                </a>
                <div class="uk-navbar-dropdown uk-box-shadow-medium">
                  <ul class="uk-nav uk-navbar-dropdown-nav">
                    <router-link :to="{ name: 'MyAccount' }" v-slot="{ href, route, navigate, isActive, isExactActive }">
                      <li :class="[isActive && 'uk-active', isExactActive && 'uk-active']">
                        <a :href="href" @click="navigate">
                          <span uk-icon="icon: user;"></span>
                          My Account
                        </a>
                      </li>
                    </router-link>
                    <li>
                      <a @click="logout">
                        <span uk-icon="icon: sign-out;"></span>
                        Logout
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <a class="uk-navbar-toggle uk-hidden@m uk-icon" uk-navbar-toggle-icon uk-toggle="target: #sidenav-mobile"></a>
          </div>
        </nav>

      </div>
    </div>

  </header>

</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'Header',
  computed: {
    ...mapGetters('user', ['first_name'])
  },
  methods: {
    ...mapActions('auth', ['LOGOUT']),
    logout() {
      this.LOGOUT().then( () => {
        this.$router.push( { name: 'Login' } );
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../assets/less/theme.less";

  .uk-logo {
    padding-left: 10px;
    max-width: 100px;
  }
  .uk-navbar-container {
    width: 100vw !important;

    &:not(.uk-navbar-transparent) {
      background: linear-gradient(to right, @ba-purple, lighten(@ba-purple, 10%));
    }

    .uk-navbar-toggle {
      font-size: 14px;
    }
  }
  .uk-navbar-item {
    min-height: 60px;
  }
  .uk-navbar-nav > li > a {
    min-height: 60px;
    padding: 0 8px;
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.8) !important;

    &:hover {
      color: rgba(255, 255, 255, 1) !important;
    }
    span {
      margin-left: 10px;
    }
  }
  .uk-navbar-dropdown-nav {
    a {
      font-size: .875em;
    }
    .uk-icon {
      margin-right: 8px;
    }
  }
</style>
